<template>  
  <div class="purchaseproductDetailPage">
    <mu-appbar class="XR-tab-head fixed">
      <mu-icon-button v-on:click="GoHistory" icon=":fa fa-angle-left" slot="left"/>        
      <div slot="default" class="head-content">
        <mu-tabs :value="activeTab" @change="handleTabChange">
          <mu-tab value="tab1" title="商品"/>
          <mu-tab value="tab2" title="详情"/>
          <mu-tab value="tab3" @active="handleActive" title="评论"/>
        </mu-tabs>  
      </div> 
      <mu-icon-menu icon=":fa fa-more" slot="right">
        <mu-menu-item to="/usercenter/index" title="个人中心"/>
        <mu-menu-item to="/" title="首页"/>
        <mu-menu-item to="/retail/cart" title="购物车"/>
      </mu-icon-menu>
      <!--<div slot="right">   
             
        <div class="uc-btn">
          <i class="fa fa-more"></i>
        </div>
      </div>-->
    </mu-appbar>
    
    <div v-if="activeTab === 'tab1' && !loaded" class="baseInfo">
      <div class="pic-carousel">
        <div class="show-img">
          <XR-swiper ref="swiper">
            <template v-if="productInfo.ImgList && productInfo.ImgList.length>0">
              <XR-slide v-for="(img,index) in productInfo.ImgList" :key=index>
                <img :src="img.ImgPath" :style="{width:fullWidth+'px',height:fullWidth+'px'}" />
              </XR-slide>
            </template>
            <template v-else>
              <XR-slide>
                <img src="/static/index/index-item-default.png" :style="{width:fullWidth+'px',height:fullWidth+'px'}" />
              </XR-slide>
            </template>
          </XR-swiper>        
        </div>
        <!-- <div class="img-count">1/5</div> -->
      </div>   
   
      <div class="pro-activity" v-if="productInfo.DiscountInfo != null"  :style="{  backgroundImage:'url('+siteInfo.MobileBgImage+')' }">
        <div class="activity-discountPrice">
          <span class="fontIcon">￥</span>
          <span class="price-num">{{productInfo.DiscountInfo.Price}}</span>
        </div>
        <div class="sale-price">
          <div class="price-num"><span>￥</span><span>{{productInfo.SalePriceName}}</span></div>
          <div class="desc"><i class="fa fa-time"></i>限时优惠</div>
        </div>
        <div class="calc-time">
          <p class="desc">{{calcDesc}}</p>
          <div class="countdown">
            <span class="time">{{hour1}}</span>
            <span class="time">{{hour2}}</span>
            <span class="font">:</span>
            <span class="time">{{mm1}}</span>
            <span class="time">{{mm2}}</span>
            <span class="font">:</span>
            <span class="time">{{ss1}}</span>
            <span class="time">{{ss2}}</span>
          </div>
        </div>
      </div>
      <div class="pro-info">
        <div class="pro-name">{{productInfo.ProductName}}</div>
        <div class="pro-desc">{{productInfo.SellingPoint}}</div>
        <div class="pro-price" v-if="productInfo.DiscountInfo==null">
          <p class="sale-price"><i class="fa fa-rmb"></i>{{productInfo.SalePriceName}}</p>
          <p class="del-price"><i class="fa fa-rmb"></i>{{productInfo.PriceName}}</p>
        </div>
      </div>
      <div class="pro-row attr-info" v-if="false">
        <div class="pro-title">已选</div>
        <div class="pro-content" :style="{width:proRowContentWidth+'px'}" @click="openAttrSheet">
          <div class="item">
            <template v-for="attr in productInfo.AttrList">
              <template v-for="attrValue in attr.Values">
                <span v-if="attrValue.IsSkuValue>0">{{attrValue.Name}}，</span>
              </template>
            </template>
            数量：{{skuCount}}</div>
        </div>
        <div class="pro-icon"><i class="fa fa-angle-right"></i></div>        
      </div>
      <div class="pro-row delivery-info">
        <div class="pro-title">送至</div>
        <div class="pro-content" :style="{width:proRowContentWidth+'px'}">
          <div class="item" @click="openBottomSheet">
            <i class="fa fa-location"></i>
            <span>{{deliveryAddress}}</span>
          </div>
          <div class="item" @click="openBottomSheet">
            <i class="fa fa-money2"></i>
            <span>邮费：{{deliveryMoney}}元</span>
          </div>
          <mu-bottom-sheet :open="bottomSheet" @close="closeBottomSheet">            
            <mu-picker :slots="addressSlots" :visible-item-count="5" @change="addressChange" :values="address" @itemClick="closeBottomSheet"/>
          </mu-bottom-sheet>
          <div class="item" v-if="isZiTi">
                <i class="fa fa-map-o" ></i>
               <span>支持自提:<mu-raised-button label="查询自提点" @click="open('bottom')" class="demo-raised-button"/></span>
          </div>
          <mu-popup  position="bottom" popupClass="demo-popup-bottom" :open="bottomPopup" @close="close('bottom')">
            <div class="selfPickUpShopList">              
              <mu-list-item v-if="selfPickUpList.length>0" v-for="selfPickUpItem in selfPickUpList" :key="selfPickUpItem.ShopId">
                  <div class="item-content">
                      <p class="name">{{selfPickUpItem.ShopName}}</p>
                      <p class="address">{{selfPickUpItem.Address}}</p>
                      <p class="phone">{{selfPickUpItem.ContactPerson}} {{selfPickUpItem.ContactPhone}}</p>
                  </div>
              </mu-list-item>
              <mu-list-item v-if="selfPickUpList.length==0">
                {{selfPickUpListDesc}}
              </mu-list-item>
            </div>
          </mu-popup>
        </div>
        <div class="pro-icon"><i class="fa fa-angle-right"></i></div>
      </div>
      <!-- <div class="id-shop">
        <div class="logo">
            <img :src="productInfo.ShopInfo.Logo" class="shopLogoImg">
            <p class="shop-name">{{productInfo.ShopInfo.ShopName}}</p>
        </div>
        <div class="total-count">
            <div class="item border">
                <p class="num" id="productCount">{{productInfo.ShopInfo.ProductCount}}</p>
                <p class="desc">全部商品</p>
            </div>
            <div class="item">
                <p class="num" id="guanzhuCount">{{productInfo.ShopInfo.GuanzhuCount}}</p>
                <p class="desc">关注人数</p>
            </div>
        </div>
        <div class="shop-btns">
            <div class="btn-item"><span class="link-btn">关注商家</span></div>
            <router-link :to="productInfo.ShopInfo.ShopType==1?'/':'/shop/shopIndex?shopId='+productInfo.ShopInfo.ShopId" class="jdgg"><div class="btn-item"><span class="link-btn">进店逛逛</span></div></router-link>
            <div class="btn-item"><span class="link-btn">商家资质</span></div>
        </div>
      </div> -->
      <div class="purchaseproductDetailPageImgInfo" v-if="productInfo.PcDetail" v-html="productInfo.PcDetail"></div>
      <div class="specListDiv" v-if="productInfo.SpecList && productInfo.SpecList.length>0">
        <p class="specListTitle">产品规格</p>
        <table class="specList" cellspacing="0" cellspadding="0">
          <tr v-for="specItem in productInfo.SpecList" :key="specItem.AttrId">
            <td class="specItemName">{{specItem.AttrName}}</td>
            <td class="specItemValue">
              <template v-for="valueItem in specItem.ValueList">
                {{valueItem.AttrValueName}}
              </template>
            </td>
          </tr>
        </table>
      </div>
      <mu-tabs :value="activeThreeTab" @change="handleThreeTabChange">
        <mu-tab :value="0" :title="'全部 '+evaluateCount.TotalCount"/>
        <mu-tab :value="1" :title="'好评 '+evaluateCount.Good"/>
        <mu-tab :value="2" :title="'中评 '+evaluateCount.Middler"/>
        <mu-tab :value="3" :title="'差评 '+evaluateCount.Bad"/>
        <mu-tab :value="4" :title="'有图 '+evaluateCount.WithImage"/>
      </mu-tabs>  
      <div class="id-sumary">
        <ul v-if="evaluateList.Evaluates">
          <li v-for="evaluateItem in evaluateList.Evaluates">
            <div :style="{height: timgHeight +'px'}" class="timg">
                <img  :src="evaluateItem.PjUserHeadpic"  alt="">
            </div> 
            <span class="nametime">{{evaluateItem.PjUserName}}</span>
            <span class="time">{{evaluateItem.PjDateName.split(' ')[0]}}</span>
            <div class="xing-div">
              <span class="fa fa-star" v-for="i in evaluateItem.StarLevel"></span>
            </div>
            <p class="content">{{evaluateItem.PjContent}}</p>
            <div class="pj-img-list">
                <div class="dimg" :style="{height:dimgWidth+'px'}" v-for="imgItem in evaluateItem.Images" :key="imgItem.Id" >
                  <img :src="imgItem.ImgPath" @click="goToEvaluateImg(skuId,imgItem.Id)" />
                </div>            
            </div>
            <template v-if="evaluateItem.HfUserName">              
              <span class="nametime" style="margin-top:10px;">
              <span style="color: red;">{{evaluateItem.HfDateName.split(' ')[0]}} 商家回复：</span>{{evaluateItem.HfUserName}} </span>
              <p class="content">{{evaluateItem.HfContent}}</p>
            </template>
            <mu-divider />
          </li>
          <li style="text-align:center; font-size:12px; color:#999;" v-if="evaluateList.TotalCount>15" @click="goToEvaluatePage()">查看更多</li>
          <li style="text-align:center; font-size:12px; color:#999;" v-if="evaluateList.TotalCount<=15">暂无更多</li>
        </ul>
      </div>
    </div>
    <div v-if="activeTab === 'tab2' && !loaded" class="productDetailInfo" :style="{height:fullHeight+'px'}">
      <mu-tabs :value="activeSubTab" @change="handleSubTabChange">
        <mu-tab value="subTabl" title="商品介绍"/>
        <mu-tab value="subTab2" title="规格参数"/>
        <mu-tab value="subTab3" title="包装售后"/>
      </mu-tabs>  
      
      <div v-if="activeSubTab === 'subTabl'" class="fontImgInfo" >
        <span v-html="productInfo.PcDetail"></span>
      </div>
      <div v-if="activeSubTab === 'subTab2'" class="skuAttrInfo">
        <table class="specList" cellspacing="0" cellspadding="0">
          <tr v-for="specItem in productInfo.SpecList" :key="specItem.AttrId">
            <td class="specItemName">{{specItem.AttrName}}</td>
            <td class="specItemValue">
              <template v-for="valueItem in specItem.ValueList">
                {{valueItem.AttrValueName}}
              </template>
            </td>
          </tr>
        </table>
      </div>
      <div v-if="activeSubTab === 'subTab3'" class="productDetailServiceInfo">
        <div>
          <div class="shoppromise">
            <h6>1、挑选商品</h6>
            <p>“{{siteInfo.SiteName}}”为您提供了方便快捷的商品引导及搜索功能：</p>
            <p>1) 通过搜索功能输入关键字的方法查找您想要购买的商品。</p>
            <p>2) 通过分类或者品牌导航查看并找到您想要购买的商品</p> 
          </div>
          <div class="shoppromise">
            <h6 class="blur">2、加入购物车</h6>
            <p>在您想要购买商品的详情页点击“加入购物车”，商品会添加到您的购物车中；您还可以继续挑选商品放入购物车，一起结算。</p>
            <p>1) 在购物车中，系统默认没见商品的订购数量为1件，如果您想购买多件商品，可修改购买数量。</p>
            <p>2) 在购物车中，您可以将商品删除。</p> 
            <p>3) 在购物车中，您可以直接查看到订单享受的优惠和优惠金额。</p> 
            <p>温馨提示：</p> 
            <p>1)商品价格会随着市场行情调整，当您看中某款商品时，请及时入手。</p> 
            <p>2)优惠政策、配送时间、支付方式等都有可能进行调整，请随时关注网站公布的最新信息。</p> 
          </div>
          <div class="shoppromise">
            <h6>3、确认购买</h6>
            <p>当您挑选好需购买的商品后，点击购物车中的“去结算”按钮跳转至订单信息页面。</p>
            <p>若您未登录，则出现登录框：</p>
            <p>老顾客：请在页面输入用户名和密码登录即可。</p> 
            <p>新顾客：点击页面的“立即注册”进行注册，注册成功后自动跳转至订单信息页。</p>
          </div>
          <div class="shoppromise">
            <h6 class="blur">4、填写订单信息</h6> 
            <p>1)确认收货信息：收货人姓名，地址及电话等信息。</p>
            <p>请填写正确完整的收货人姓名、收货人联系方式，详细的收货地址和邮编，否则将会影响您订单的处理或者配送。您可以进入“个人中心 - 账户管理” 设置默认收货地址，保存成功后，再订购时，可以直接选择使用。</p> 
            <p>2)确认配送方式：确认详细的配送方式、送达时间等信息。</p>
            <p>3)确认支付方式：选择合适您的支付方式。住：目前提供在线支付、银行汇款、货到付款、到店自提、分期付款。</p>
            <p>4)索取发票：填写正确的发票抬头、选择正确的发票内容，发票选择成功后，将于订单货物一起送到 。</p>
            <p>5)确认商品清单：确认购买商品的品类、数量、价格、金额及促销、优惠等信息。</p>
          </div>
          
          <div class="shoppromise">
            <h6>5、提交订单、商品结算</h6>
            <p>1)以上信息核实无误后，请点击“提交订单”，系统生成一个订单号，提示您已经成功提交订单。</p>
            <p>2)订单提交成功后，您可以登录“我的账户-订单中心”管理订单信息。</p> 
          </div>
          <div class="shoppromise">
            <h6 class="blur">6、订单状态</h6>
            <p>待审核：订单提交成功后，等待客服确认订单信息。</p>
            <p>审核通过：订单审核成功，客服为您安排发货。</p> 
            <p>已发货：订单商品已经从库房发出，配送人员已经出发。</p> 
            <p>已签收：买家已签收为您配送的商品。</p> 
            <p>拒签收，由于特殊原因，买家决绝签收包裹。</p> 
            <p>已完成：订单被正常签收或者部分收货，此订单正常流转完成。</p> 
            <p>已取消：订单有用户主动取消或者系统自动取消。</p> 
          </div>
          <div class="shoppromise">
            <h6>电话订购：</h6>
            <p>您可以直接从“{{siteInfo.SiteName}}”上挑选您喜欢的商品，然后拨打我们的贵宾专线，把商品编号告诉客服，我们将协助您完成商品购买。</p> 
          </div>
          <div class="shoppromise gray"> 
              <p>贵宾专线：0371-60943919</p>
              <p>客服工作时间：周一~周五  9:00~17:30</p>
              <p>客服邮箱：1787682943@qq.com</p> 
          </div>
          <div class="clearfix"></div>  
        </div>
      </div>
    </div>
    <div v-if="activeTab === 'tab3' && !loaded" class="purchaseproductDetailEvalue" :style="{height:fullHeight+'px'}">
      <mu-tabs :value="activeThreeTab" @change="handleThreeTabChange">
        <mu-tab :value="0" :title="'全部 '+evaluateCount.TotalCount"/>
        <mu-tab :value="1" :title="'好评 '+evaluateCount.Good"/>
        <mu-tab :value="2" :title="'中评 '+evaluateCount.Middler"/>
        <mu-tab :value="3" :title="'差评 '+evaluateCount.Bad"/>
        <mu-tab :value="4" :title="'有图 '+evaluateCount.WithImage"/>
      </mu-tabs>  
      <div class="id-sumary">
        <ul v-if="evaluateList.Evaluates">
          <li v-for="evaluateItem in evaluateList.Evaluates">
            <div  class="timg" :style="{height: timgHeight +'px'}">
                <img :src="evaluateItem.PjUserHeadpic" alt="">
            </div> 
            <span class="nametime">{{evaluateItem.PjUserName}}</span>
            <span class="time">{{evaluateItem.PjDateName.split(' ')[0]}}</span>
            <div class="xing-div">
              <span class="fa fa-star" v-for="i in evaluateItem.StarLevel"></span>
            </div>
            <p class="content">{{evaluateItem.PjContent}}</p>
            <div class="pj-img-list">                
              <div class="dimg" :style="{height:dimgWidth+'px'}" v-for="imgItem in evaluateItem.Images" :key="imgItem.Id" >
                <img :src="imgItem.ImgPath" @click="goToEvaluateImg(skuId,imgItem.Id)" />
              </div> 
            </div>
            <template v-if="evaluateItem.HfUserName">              
              <span class="nametime" style="margin-top:10px;">
              <span style="color: red;">{{evaluateItem.HfDateName.split(' ')[0]}} 商家回复：</span>{{evaluateItem.HfUserName}} </span>
              <p class="content">{{evaluateItem.HfContent}}</p>
            </template>
            <mu-divider />
          </li>
          <li style="text-align:center; font-size:12px; color:#999;" v-if="evaluateList.TotalCount>15" @click="goToEvaluatePage()">查看更多</li>
          <li style="text-align:center; font-size:12px; color:#999;" v-if="evaluateList.TotalCount<=15">暂无更多</li>
        </ul>
      </div>
    </div>


    <mu-bottom-sheet :open="attrSheet" @close="closeAttrSheet">    
      <div class="purchaseproductDetailPage-skuSaleInfo">
        <div class="pro-img">
          <img :src="productInfo.SkuImage" class="img" v-if="productInfo.SkuImage" />
          <img :src="productInfo.ImgList[0].ImgPath" class="img" v-else-if="productInfo.ImgList" />
          <img :src="IMGServer_URL+'/images/index-item-default.png'" class="img" v-else/>
        </div>
        <div class="info">
          <p class="price">￥{{productInfo.DiscountInfo == null ? productInfo.SalePriceName :productInfo.DiscountInfo.Price}}</p>
          <p class="stock">库存：{{productInfo.DiscountInfo == null ? productInfo.Stock :productInfo.DiscountInfo.Stock}}</p>
        </div>
      </div>   
      <div style="clear:both;"></div>  
      <div class="purchaseproductDetailPage-scroll">            
        <div class="purchaseproductDetailPage-attrList">            
          <div class="attr" v-for="attr in productInfo.AttrList" :key="attr.Id">
            <div class="attrName">{{attr.Name}}</div>
            <div class="attrValueList">
              <div :class="'attrValue '+getSkuClassSelect(attr.Id,attrValue.Id,attrValue.Name)" v-for="attrValue in attr.Values" :key="attrValue.Id" @click="skuTab(attr.Id,attrValue.Id,attrValue.Name)">
                <template v-if="attr.AttrType==1 && attrValue.IconPath"><img :src="imgServerUrl+'/api/img/getPath?id='+attrValue.IconPath" class="attrIcon" /></template>
                <template v-if="attr.AttrType==3 && attrValue.Color"><span class="attrIcon" :style="{background:attrValue.Color}" ></span></template>
                <span class="attrValueText">{{attrValue.Name}}</span>
              </div>
            </div>
          </div>
        </div>   
        <div class="purchaseproductDetailPage-jiajian">
          <div class="purchaseproductDetailPage-jiajian-ctrl">
            <span class="btn jian" @click="minusCartItem(productInfo.SkuId, productInfo.Stock)">-</span>
            <span class="count">{{skuCount}}</span>
            <span class="btn jia" @click="plusCartItem(productInfo.SkuId, productInfo.Stock)">+</span>
          </div>
        </div>
      </div>
      <div class="purchaseproductDetailPage-btn">
        <template v-if="attrSheetType == 1">
          <div class="btn" @click="joinCart" v-if="salesmanInfo.UserBs > 1">加入购物车</div>        
          <div class="btn disabled" @click="showCartErrorMsg" v-if="salesmanInfo.UserBs <= 1">加入购物车</div>
        </template>    
        <template v-if="attrSheetType == 2">
          <div class="btn" @click="goBuy">立即购买</div>  
        </template>    
      </div>
    </mu-bottom-sheet>

    <div class="purchaseproductDetailBottomButton">
      <div class="content">
        <!-- <router-link :to="productInfo.ShopInfo.ShopType==1?'/':'/shop/shopIndex?shopId='+productInfo.ShopInfo.ShopId"><div class="btn"><i class="fa fa-house1"></i><p>店铺</p></div></router-link> -->
        <!-- <div :class="favState?'btn faved':'btn'" @click="favClick"><i class="fa fa-aixin"></i><p>收藏</p></div> -->
        <div class="btn" v-if="salesmanInfo.UserBs > 1">
          <router-link to="/wholesale/cart">
            <mu-badge :content="cartCount" circle secondary badgeClass="msg-badge">
              <i class="fa fa-shopping-cart2"></i><p>购物车</p>
            </mu-badge>
          </router-link>
        </div>
        <div class="btn" v-if="salesmanInfo.UserBs <= 1" @click="showCartErrorMsg">
          <mu-badge :content="cartCount" circle secondary badgeClass="msg-badge">
            <i class="fa fa-shopping-cart2"></i><p>购物车</p>
          </mu-badge>
        </div>
      </div>
      <div class="btn-list">        
        <div class="btn" @click="openAttrSheet(1)" v-if="salesmanInfo.UserBs > 1">加入购物车</div>
        <div class="btn disabled" @click="showCartErrorMsg" v-if="salesmanInfo.UserBs <= 1">加入购物车</div>
        <div class="btn" @click="openAttrSheet(2)" v-if="salesmanInfo.UserBs > 0">立即购买</div>
        <div class="btn disabled" @click="showCartErrorMsg" v-if="salesmanInfo.UserBs <= 0">立即购买</div>
      </div>
    </div>
    <XR-toast ref="XRtoast"></XR-toast>
  </div>
</template>

<script>
import cart from '../../util/purchaseCart'
import siteconfig from '../../util/siteconfigCache'
var address = {
  '北京': {'北京':['北京']},
  '湖北': {'武汉':['武昌区','汉阳区','青山区'], '黄石':['黄石']},
  '台湾': {'台北市':['台北市']}
}

export default {
  name : 'XR-tab-head',
  data () {
    return {
      bottomPopup: false,
      activeTab: 'tab1',
      activeSubTab: 'subTabl',
      activeThreeTab: 0,
      evaluateList:[],
      evaluateCount : {
        TotalCount:0, 
        Good:0,
        Middler:0,
        Bad:0,
        WithImage:0
      },
      fullWidth : document.documentElement.clientWidth,
      fullHeight: (parseInt(document.documentElement.clientHeight)-48), 
      dimgWidth : (document.documentElement.clientWidth-16)*0.32,
      timgHeight:  (document.documentElement.clientWidth-16)*0.09,
      proRowContentWidth: (parseInt(document.documentElement.clientWidth)-80),
      bottomSheet: false,
      attrSheet:false,
      attrSheetType:1,
      selectAddress:'',
      addressSlots: [
        {
          width: '100%',
          textAlign: 'right',
          values: ['北京']
        }, {
          width: '100%',
          textAlign: 'center',
          values: ['北京市']
        }, {
          width: '100%',
          textAlign: 'left',
          values: ['东城区']
        }
      ],
      address: ['全部', '全部','全部'],
      addressProvince: '全部',
      addressCity: '全部',
      addressArea: '全部',
      deliveryAddress:'请选择送货区域',
      loaded:true,
      productInfo:{
        ShopInfo:{},
        IntegralSale:{}
      },
      skuTabList:[],
      skuId:this.$route.query.skuId,
      skuCount:1,
      cartCount:'0',
      favState : false,
      SessionId:this.$store.state.user.SessionId,      
      startTime :'',
      endTime:'',
      calcDesc:'',
      buynowInterval :0,
      hour1:'0',
      hour2:'0',
      mm1:'0',
      mm2:'0',
      ss1:'0',
      ss2:'0',
      deliveryMoney:0,
      imgServerUrl : this.IMGServer_URL,
      isZiTi: false,
      selfPickUpList:[],
      selfPickUpListDesc:'请选择区域',      
      siteInfo: {},
      salesmanInfo:{UserBs:0},
      datalock: false,
      canTabSkuList:[],
      skuTabMode: 'select'
    }
  },
  mounted(){
    this.$refs.XRtoast.load()   
    var ths = this

    if (!this.$store.state.user.SessionId) {
      ths.initData()
    }else{      
      this.getSalesmanInfo(function(){      
        ths.initData()
      }) 
    }
  },
  methods: {    
    initData :function(){
      var ths = this
      ths.getSiteInfo()
      ths.getProductDetail()
      ths.getCartCount()
      ths.getAreaList()  
      ths.getDeliveryAreaCache()  
      ths.AddProductSkuBrowserCount()
    },
    getSalesmanInfo: function(callback) {
      const ths = this;
      this.$post("/Salesman/SalesmanServer/GetSalesmanIndexInfo")
      .then(function(res) {
        if (res.IsSuccess) {
          ths.salesmanInfo = res.Data
        }

        callback()
      })
      .catch(function(err) {
        console.log(err);
      });
    },      
    getSiteInfo: function() {
      const ths = this;
      this.$post("/Shop/SiteConfigServer/GetSiteConfig")
      .then(function(res) {
        if (res.IsSuccess) {
          ths.siteInfo = res.Data;
          siteconfig.addSiteconfig(res.Data)
        }
      })
      .catch(function(err) {
        console.log(err);
      });
    },    
    open (position) {
      if(position=='bottom'){
        if(this.isZiTi){          
          this.GetSelfPickUpSiteShopList()
        }
      }
      this[position + 'Popup'] = true
    },
    close (position) {
      this[position + 'Popup'] = false
    },
    AddProductSkuBrowserCount(){      
      var ths = this;   
      ths.$post(
        "/Shop/PurchaseServer/AddProductSkuBrowserCount",{skuId:this.skuId}
      ).then(function(res) {
      });
    },
    getDeliveryAreaCache(){      
      var provinceCache = window.localStorage.ProductDetailDeliveryProvinceCache
      if(provinceCache){
        this.addressProvince = provinceCache
      }
      var cityCache = window.localStorage.ProductDetailDeliveryCityCache
      if(cityCache){
        this.addressCity = cityCache
      }
      var areaCache = window.localStorage.ProductDetailDeliveryAreaCache
      if(areaCache){
        this.addressArea = areaCache
      }
      this.address = [this.addressProvince, this.addressCity, this.addressArea]
    },
    getFavState: function(){
      if(this.SessionId){
        var ths = this;   
        ths.$post(
          "/Shop/PurchaseServer/GetFavoriteState",
          JSON.stringify({skuId:this.skuId})
        ).then(function(res) {
          ths.favState = res.IsSuccess
        });
      }
    },
    favClick(){
      if(this.favState){
        this.cancelFav()
      }
      else{
        this.addFav()
      }
    },
    addFav(){
      if(this.SessionId){
        var ths = this;   
        ths.$post(
          "/Shop/PurchaseServer/AddFavorite",
          JSON.stringify({skuId:this.skuId})
        ).then(function(res) {
          ths.favState = res.IsSuccess
          ths.$refs.XRtoast.success(res.Msg, true)
        });
      }
      else{
        this.$refs.XRtoast.failed("未登录", true);
      }
    },
    cancelFav(){      
      if(this.SessionId){
        var ths = this;   
        ths.$post(
          "/Shop/PurchaseServer/CancelFavoriteBatch",
          JSON.stringify({skuIds:[this.skuId]})
        ).then(function(res) {
          if(res.IsSuccess){
            ths.favState = false
            ths.$refs.XRtoast.success(res.Msg, true)
          }
        });
      }
      else{
        this.$refs.XRtoast.failed("未登录", true);
      }
    },
    getAreaList(){
      var ths = this;   
      ths.$post(
        "/Shop/BaseServer/GetAreaAllListGroup"
      ).then(function(res) {
        if(!res.IsSuccess){
          ths.$refs.XRtoast.failed(res.Msg, true)
        }else{     
          address= JSON.parse(res.Data) 
          ths.addressSlots[0].values = Object.keys(address)   
          
          if(ths.$route.query.id){ 
            ths.getInfo()
          }else{
            ths.loaded = false
            ths.$refs.XRtoast.hide()
          }    
        }
      });
    },    
    goToEvaluateImg(skuId, imgId){
      this.$router.push('/retail/productDetailImg?skuId='+skuId + '&imgId='+imgId)
    },
    addressChange (value, index) {
      switch (index) {
        case 0:
          this.addressProvince = value
          var cirtyList = address[value]
          var keys = Object.keys(cirtyList)          
          this.addressSlots[1].values = keys
          this.addressCity = keys[0]
          
          var areaList = address[this.addressProvince][this.addressCity]        
          this.addressSlots[2].values = areaList
          this.addressArea = areaList[0]
          break
        case 1:      
          this.addressCity = value
          var arr1 = address[this.addressProvince][value]          
          this.addressSlots[2].values = arr1
          this.addressArea = arr1[0]
          break
        case 2:
          this.addressArea = value          
          break
      }

      window.localStorage.ProductDetailDeliveryProvinceCache =this.addressProvince
      window.localStorage.ProductDetailDeliveryCityCache = this.addressCity
      window.localStorage.ProductDetailDeliveryAreaCache = this.addressArea
      this.address = [this.addressProvince, this.addressCity, this.addressArea]
    },
    getProductDetail:function(){
      var ths = this;   
      ths.$post(
        "/Shop/PurchaseServer/GetProductDetail",
        JSON.stringify({skuId:this.skuId})
      ).then(function(res) {
        ths.datalock = false
        if(!res.IsSuccess){
          ths.$refs.XRtoast.failed(res.Msg, true)
        }else{      
          ths.$refs.XRtoast.hide()
          ths.productInfo = res.Data
          ths.isZiTi = ths.productInfo.IsZiTi

          ths.skuTabList = []
          if(ths.productInfo.AttrList){
            for(var i = 0; i< ths.productInfo.AttrList.length;i++){
              var attr = ths.productInfo.AttrList[i]
              
              for(var j = 0; j< attr.Values.length;j++){
                var attrValue = attr.Values[j]
                var attrSelect = {}
                attrSelect.attrId = attr.Id
                attrSelect.isClick = 0
                attrSelect.isCache = 0 //缓存点击记录
                attrSelect.IsSkuValue = attrValue.IsSkuValue 
                attrSelect.attrValueId = attrValue.Id
                if (attrSelect.attrValueId == 0){
                  attrSelect.attrValueUserDefine = attrValue.Name
                }
                ths.skuTabList.push(attrSelect)
              }
            }
          }
          ths.loaded= false
          ths.getEvaluateList(function(){
            ths.evaluateCount = ths.evaluateList;
          }) 
        }
      });
    },
    getEvaluateList(callback){
      var ths = this;   
      ths.$refs.XRtoast.load('加载中...',false)
      var json = {skuId:this.skuId, TypeId: this.activeThreeTab}
      ths.$post(
        "/Shop/RetailServer/GetProductEvaluateList",
        json
      ).then(function(res) {
         ths.$refs.XRtoast.hide()
         if(!res.IsSuccess){
          ths.evaluateList = {}
          //ths.$refs.XRtoast.failed(res.Msg, true)
        }else{      
          ths.evaluateList = res.Data  
          callback()       
          ths.loaded= false
        }
      });
    },
    getFreightWeightByCode(){      
        var ths = this;   
        var data = {
          Skus:[{skuId:this.skuId,count:this.skuCount}],
          ShoppingMethod: 1, 
          ProvinceCode: this.addressProvince, 
          CityCode: this.addressCity, 
          AreaCode: this.addressArea 
        };
        ths.$post(
          "/Shop/PurchaseServer/GetFreightByAddressCode", data
        ).then(function(res) {
          if(res.IsSuccess){
            ths.deliveryMoney = res.Data
          }else{
            ths.deliveryMoney = ''
          }
        });
    },
    GetSelfPickUpSiteShopList(){      
        var ths = this;   
        var data = {
          SkuId:this.skuId,
          Province: this.addressProvince, 
          City: this.addressCity, 
          Area: this.addressArea 
        };
        ths.$post(
          "/Shop/PurchaseServer/GetSelfPickUpSiteShopList", data
        ).then(function(res) {
          if(res.IsSuccess){
            ths.selfPickUpList = res.Data
            ths.selfPickUpListDesc = res.Msg
          }else{
            ths.selfPickUpList = []
            ths.selfPickUpListDesc = res.Msg
          }
        });
    },
    getCartCount(){
      this.cartCount =cart.getCount().toString()
    },
    GoHistory(){
      this.$router.goBack()
    },
    handleTabChange (val) {
      var ths =this
      ths.activeTab = val
      if(ths.activeTab == "tab3"){
        ths.getEvaluateList(function(){
          ths.evaluateCount = ths.evaluateList;
        })        
      }
    },
    handleSubTabChange (val) {
      this.activeSubTab = val
    },
    handleThreeTabChange (val) {
      this.activeThreeTab = val
      this.getEvaluateList()
    },
    handleActive () {
    },    
    closeBottomSheet () {
      this.bottomSheet = false
    },
    openBottomSheet () {
      this.bottomSheet = true
    },
    joinCart(){
      var ths = this
      if(ths.salesmanInfo.UserBs<=0){
        ths.$refs.XRtoast.failed("您没有权限", true)
        return
      }
      this.getSalesmanInfo(function(){
        if(ths.salesmanInfo.UserBs<=0){
          ths.$refs.XRtoast.failed("您没有权限", true)
          return
        }
        ths.closeAttrSheet()
        if(ths.productInfo.State != 0){
          ths.$refs.XRtoast.failed("即将上架，敬请期待.", true)
          return
        }      
        var cartCount = 0;
        var cartItem = cart.getItem(ths.productInfo.SkuId)
        if(cartItem.count){
          cartCount = cartItem.count;
        }
        if(cartCount+ths.skuCount > ths.productInfo.Stock){
          ths.$refs.XRtoast.failed("库存不足", true)
          return
        }
        cart.addItem(ths.productInfo.SkuId, ths.skuCount)
        ths.getCartCount()
        ths.$refs.XRtoast.success("添加成功", true)
      })
    },
    openAttrSheet(type){
      var ths = this
      if(ths.salesmanInfo.UserBs<=0){
        ths.$refs.XRtoast.failed("您没有权限", true)
        return
      }
      this.getSalesmanInfo(function(){
        ths.attrSheet = true
        ths.attrSheetType = type
      })
    },
    closeAttrSheet(){
      this.attrSheet = false
    },
    showCartErrorMsg(){
      var msg = '您无权限'
      if(this.salesmanInfo.UserBs ==1 ){
        msg = '请点击立即购买按钮进行购买'
      }

      this.closeAttrSheet()
      this.$refs.XRtoast.failed(msg, true)
    },
    skuTab(attrId, attrValueId, attrValueName){
      
      var isSelect = this.getSkuClassSelect(attrId, attrValueId,attrValueName)
      if(isSelect!='' && isSelect != 'canSelect'){
        return;
      }

      console.info(JSON.stringify('datalock：'+this.datalock))
      if(this.datalock == false){
        this.datalock = true
        var isTab = false     
        for(var i = 0; i < this.skuTabList.length;i++){
          var sku = this.skuTabList[i]
          sku.isClick= 0
        }
        for(var i = 0; i< this.skuTabList.length;i++){
          //clearTimeout(this.timer)
          var sku = this.skuTabList[i]
          if(attrId == sku.attrId){
            if(attrValueId >0 && attrValueId == sku.attrValueId || attrValueName == sku.attrValueUserDefine){
              sku.isClick= 1
              sku.isCache = 1
              sku.IsSkuValue= 1
              //this.timer = setTimeout(()=>{
                isTab = true 
                this.getAttrValue(isTab)       
              //},500) 
            }else{
              sku.IsSkuValue= 0
            }
          }
        }       
      }
    },    
    getAttrValue(isTab){
      console.log(isTab)
      if(isTab){
        var ths = this;  
        
        var clickSkuAttrId = 0
        var selectSku = []
        for(var i = 0; i< this.skuTabList.length;i++){
          var curSku = this.skuTabList[i]
          if(curSku.isClick == 1){
            selectSku.push(curSku)
            clickSkuAttrId = curSku.attrId
          }
        }
        for(var i = 0; i< this.skuTabList.length;i++){
          var curSku = this.skuTabList[i]
          if(curSku.IsSkuValue){
            var isContain = false
            for(var j = 0; j < selectSku.length;j++){
              if(curSku.attrId == selectSku[j].attrId){                  
                isContain=true
              }
            }
            if(!isContain){
              selectSku.push(curSku)
            }
          }
        }


        ths.$post(
          "/Shop/PurchaseServer/GetSkuByAttrValue",
          JSON.stringify({ productId:this.productInfo.ProductId, attrValues: selectSku})
        ).then(function(res) {    
          if(!res.IsSuccess){     
            ths.datalock = false
            if(res.TypeId != 1){
              ths.$refs.XRtoast.failed(res.Msg, true)
            }
            if(res.Data){
              for(var k = 0; k < ths.skuTabList.length;k++){
                var sku = ths.skuTabList[k]
                sku.isCan = 0
                for(var i =0; i< res.Data.length; i++){
                  if(sku.attrId == res.Data[i].AttrId ){
                    if(res.Data[i].Values){                    
                      for(var j =0; j< res.Data[i].Values.length; j++){
                        if(
                            res.Data[i].Values[j].AttrValueId> 0 && sku.attrValueId == res.Data[i].Values[j].AttrValueId
                            || res.Data[i].Values[j].AttrValueId ==0 && sku.attrValueUserDefine == res.Data[i].Values[j].AttrValueUserDefine
                        ){
                          if(clickSkuAttrId != sku.attrId){
                            sku.isCan = 1
                            ths.skuTabMode = 'can'
                          }
                        }
                      }
                    }
                  }
                }
              }
              var tempData ={attrId:-999999}
              ths.skuTabList.push(tempData)
              ths.skuTabList.splice(ths.skuTabList.length-1)
            }
            console.info(JSON.stringify(ths.skuTabList))
          }else{   
            ths.skuTabMode= 'select'             
            ths.skuId=res.Msg
            ths.getProductDetail()
          }         
        })    
      }
    },
    
    getSkuClassSelect(attrId,attrValueId, attrValueName){
      if(this.datalock == false){
        for(var i = 0; i< this.skuTabList.length;i++){
          var sku = this.skuTabList[i]
          if(attrId == sku.attrId && attrValueId == sku.attrValueId){  
            if((attrValueId>0 && attrValueId == sku.attrValueId || attrValueName == sku.attrValueUserDefine)){
              console.info(this.skuTabMode)

              if(this.skuTabMode == 'can'){
                if(sku.isClick==1){
                  return 'select'
                }else if(sku.isCache==1){
                  return 'select'
                }else if(sku.isCan==1){
                  return 'canSelect'
                }else{
                  return 'cannotSelect'
                }
              }else{
                if(sku.IsSkuValue==1){
                  return 'select'
                }
              }
            }       
          }
        }
      }
      return ''
    },
    plusCartItem: function(skuId , stock){
      var ths = this
      if(ths.salesmanInfo.UserBs<=0){
        ths.$refs.XRtoast.failed("您没有权限", true)
        return
      }
      ths.getSalesmanInfo(function(){
        if(ths.skuCount+1 > stock ){
          ths.closeAttrSheet()
          ths.$refs.XRtoast.failed("不能再加了", true);
          return;
        }
        ths.skuCount++ 
      })
    },
    minusCartItem: function(skuId , stock){
      var ths = this
      if(ths.salesmanInfo.UserBs<=0){
        ths.$refs.XRtoast.failed("您没有权限", true)
        return
      }
      ths.getSalesmanInfo(function(){
        if(this.skuCount-1 < 1){
          this.closeAttrSheet()
          this.$refs.XRtoast.failed("不能再减了", true);
          return;
        }
        this.skuCount--
      })
    },
     
    countdownEvent : function () {
        //结束倒计时
        if (this.endTime) {
            var ts = (new Date(this.endTime)) - (new Date()); //计算剩余的毫秒数    
            if (ts <= 0) {
                clearInterval(this.buynowInterval);
                return;
            }
            this.calcTime(ts);
            return;
        }

        //开始倒计时
        var startTime = this.startTime;
        if (startTime) {
            var ts = (new Date(startTime)) - (new Date()); //计算剩余的毫秒数    
            if (ts <= 0) {
                clearInterval(this.buynowInterval);
                return;
            }
            this.calcTime(ts);
            return;
        }
    },
    calcTime : function (ts) {
        var hh = parseInt(ts / 1000 / 60 / 60, 10); //计算剩余的小时数  
        var mm = parseInt(ts / 1000 / 60 % 60, 10); //计算剩余的分钟数  
        var ss = parseInt(ts / 1000 % 60, 10); //计算剩余的秒数  

        this.hour1 = parseInt(hh / 10);
        this.hour2 = hh % 10;
        this.mm1 = parseInt(mm / 10);
        this.mm2 = mm % 10;
        this.ss1 = parseInt(ss / 10);
        this.ss2 = ss % 10;
    },
    goBuy(){      
      var ths = this
      if(ths.salesmanInfo.UserBs<=0){
        ths.$refs.XRtoast.failed("您没有权限", true)
        return
      }
      ths.getSalesmanInfo(function(){
        var skuId = ths.skuId
        ths.$router.push('/wholesale/orderSubmit?skuId='+skuId + '&count='+ ths.skuCount)
      })
    }
  },
  watch:{
    address(){    
      this.deliveryAddress = this.addressProvince + ' > ' + this.addressCity + ' > ' +this.addressArea

      if(this.addressProvince != '全部' && this.addressCity != '全部' && this.addressArea != '全部'){
        this.getFreightWeightByCode()
      }
    }
  }
}
</script>

<style>
.purchaseproductDetailPage {  
  padding-bottom: 112px;
}
.purchaseproductDetailPage .XR-tab-head{
  height: 48px;
  text-align: center;
}
.purchaseproductDetailPage .XR-tab-head.fixed{  
  padding:0;
  position: fixed;
  top:0;
  left: 0;
  z-index: 10;
}
.purchaseproductDetailPage .XR-tab-head .mu-appbar-title {
  font-size: 16px;
}
.purchaseproductDetailPage .XR-tab-head .title .mu-icon-button {
  position: absolute;
  left: 0;
  top: 0;
  color:white;
}
.purchaseproductDetailPage .XR-tab-head .title .title-text {
  margin: 0;
  line-height: 48px;
}
.productDetailServiceInfo{
  background: #fff;
  padding: 16px;
}

.purchaseproductDetailPage .baseInfo{  
  padding-bottom: 56px;
  padding-top: 48px;
}
.purchaseproductDetailPage .XR-tab-head .head-content{
  overflow: hidden;
  line-height: 48px;
}
.fontImgInfo p:first-child{
  padding: 8px 16px;
}
.purchaseproductDetailPageImgInfo p:first-child{
  
}

.purchaseproductDetailPage .pic-carousel {
  width: 100%;
  position: relative;
}
.purchaseproductDetailPage .pic-carousel .show-img {
  overflow: hidden;
}
.purchaseproductDetailPage .pic-carousel .show-img img{
  display: block;
}
.purchaseproductDetailPage .pic-carousel .img-count{
  position: absolute;
  bottom: 20px;
  right: 20px;
  background: #ddd;
  padding:0 10px;
  height: 20px;
  line-height: 20px;
  border-radius: 10px;
  color:white;
}


.purchaseproductDetailPage .pro-activity{
  background:url('/static/us-top-bg.png') left center; 
  height:50px;
}
.purchaseproductDetailPage .pro-activity .activity-discountPrice{
  float:left; 
  line-height:50px;
  font-size:24px;
  font-weight:700;
  color:white;
  overflow: hidden;
  margin-left: 10px;
  height: 50px;
}
.purchaseproductDetailPage .pro-activity .activity-discountPrice .fontIcon{
  font-size:12px;
  letter-spacing: -3px;
}
.purchaseproductDetailPage .pro-activity .sale-price{
  float:left; 
  padding:8px 0 8px 15px;
}
.purchaseproductDetailPage .pro-activity .sale-price .price-num{
  line-height:16px;
  font-size:14px;
  color:white;
  text-decoration: line-through;
  padding-bottom: 2px;
}
.purchaseproductDetailPage .pro-activity .sale-price .desc{
  line-height:14px;
  font-size:14px;
  color:white; 
  border:1px solid white;
}
.purchaseproductDetailPage .pro-activity .sale-price .desc i{
  background:white;
  color:red;
}
.purchaseproductDetailPage .calc-time{
  float:right;
  width: 120px;
  height: 50px;
  background: #efefef;
  color:#666;
}
.purchaseproductDetailPage .calc-time .desc{
  text-align: center;
  line-height: 20px;
  height: 20px;
  font-size: 12px;
}
.purchaseproductDetailPage .calc-time .countdown{
  text-align: center;
}
.purchaseproductDetailPage .calc-time .countdown .time{
  font-size:18px; 
  width:12px; 
  height:23px; 
  line-height: 23px;
  text-align:center; 
  background:url(/static/active/countdown.png) no-repeat; 
  color:white;
  display: inline-block;
}
.purchaseproductDetailPage .calc-time .countdown .font{
   font-size:12px; 
   width:1px; 
   text-align:center; 
   color:#666;
  display: inline-block;
}

.purchaseproductDetailPage .pro-info{
  background: white;
  padding: 10px 10px 15px;
  font-size: 12px;
}
.purchaseproductDetailPage .pro-info .pro-name{
  line-height: 16px;
  overflow: hidden;
}
.purchaseproductDetailPage .pro-info .pro-desc{
  color:red;
  margin-top: 10px;
}

.purchaseproductDetailPage .pro-info .pro-price{
  margin-top: 10px;
  overflow: hidden;
}
.purchaseproductDetailPage .pro-info .pro-price .sale-price{
  color:red;
  font-size: 20px;
  font-weight: 700;
  float: left;
}
.purchaseproductDetailPage .pro-info .pro-price .sale-price .fa{
  font-size: 14px;
}
.purchaseproductDetailPage .pro-info .pro-price .del-price{
  font-size: 12px;
  float: left;
  text-decoration: line-through;
  color:#999;
  line-height: 30px;
  padding-left: 20px;
}


.purchaseproductDetailPage .pro-row{
  margin-top: 10px;
  background: white;
  padding: 10px 0 10px 10px;
  line-height: 28px;
  overflow: hidden;
  width: 100%;
}
.purchaseproductDetailPage .pro-row .pro-title{
  width: 40px;
  font-size: 12px;
  color:#999;
  float: left;
}
.purchaseproductDetailPage .pro-row .pro-content{
  width: 40px;
  font-size: 12px;
  color:#999;
  float: left;
  color:black;
}
.purchaseproductDetailPage .pro-row .pro-content .mu-raised-button{
  box-shadow: none;
}
.demo-popup-bottom{width: 100%;}
.demo-popup-bottom .selfPickUpShopList{max-height: 400px; overflow-y: scroll;}
.demo-popup-bottom .item-content p{
  line-height: 25px;
}
.demo-popup-bottom .item-content .name{
  color: #000;
}
.demo-popup-bottom .item-content .address,.demo-popup-bottom .item-content .phone{
  font-size: 12px;
  color: #666;
}
.purchaseproductDetailPage .pro-row .pro-content .item{
  overflow: hidden;
}
.purchaseproductDetailPage .pro-row .pro-content .item .fontIcon{
  float: left;
  font-size: 12px;
  background: red;
  text-align: center;
  color:white;
  border-radius: 2px;
  width: 14px;
  height: 14px;
  line-height: 14px;
  margin: 7px 1px;
}
.purchaseproductDetailPage .pro-row .pro-content .item .text{
  float: left;
  margin-left: 10px;
}
.purchaseproductDetailPage .pro-row .pro-icon{
  width: 20px;
  font-size: 12px;
  color:#999;
  float: left;
  text-align: center;
}

.purchaseproductDetailPage .id-shop { overflow:hidden; margin:10px 0; background:white;}
.purchaseproductDetailPage .id-shop .logo { overflow:hidden; padding:10px 15px 0;}
.purchaseproductDetailPage .id-shop .logo img { display:block; float:left; width:60px;}
.purchaseproductDetailPage .id-shop .logo .shop-name { float:left; margin-left:10px;}
.purchaseproductDetailPage .id-shop .total-count { overflow:hidden;}
.purchaseproductDetailPage .id-shop .total-count .item { float:left; width:50%; text-align:center; position:relative; font-size:12px;}
.purchaseproductDetailPage .id-shop .total-count .item.border:after { content:''; position:absolute; top:0; right:0; bottom:0; width:1px; background:#ddd;}
.purchaseproductDetailPage .id-shop .total-count .item .desc { color:#999;}
.purchaseproductDetailPage .id-shop .shop-btns { overflow:hidden; height:60px; padding:10px 10% 0;}
.purchaseproductDetailPage .id-shop .shop-btns .btn-item { width:33%; float:left; text-align:center; line-height:60px;}
.purchaseproductDetailPage .id-shop .shop-btns .btn-item .link-btn {border:1px solid #ccc; padding:4px 10px; border-radius:5px; font-size:12px; color:#999;}
    


.purchaseproductDetailPage .purchaseproductDetailPageImgInfo{
  margin-top: 10px;
  overflow: hidden;
}
.purchaseproductDetailPage .purchaseproductDetailPageImgInfo img{
  width: 100%;
  display: block;
}

.purchaseproductDetailPage-skuSaleInfo {
  height: 75px;
}
.purchaseproductDetailPage-skuSaleInfo .pro-img{
  float: left;
}
.purchaseproductDetailPage-skuSaleInfo .img{
  margin-top:-15px;
  margin-left: 15px;
  border: 1px solid #eee;
  border-radius: 5px;
  width: 80px;
  height: 80px;
  display: block;
}
.purchaseproductDetailPage-skuSaleInfo .info{  
  float: left;
  padding: 20px 0 0 15px;
}
.purchaseproductDetailPage-skuSaleInfo .info .price{  
  font-size: 16px;
  line-height: 24px;
  font-weight: 700;
  color:Red;
}
.purchaseproductDetailPage-skuSaleInfo .info .skuid{ 
  font-size: 12px;
}

.purchaseproductDetailPage-scroll {
  overflow-x: hidden;
  overflow-y: scroll;
  max-height: 250px;
}
.purchaseproductDetailPage-attrList {
  overflow: hidden;
}
.purchaseproductDetailPage-attrList .attr{  
  border-top:1px solid #eee;
  padding: 0 10px;
}
.purchaseproductDetailPage-attrList .attr .attrName{
  line-height: 34px;
}
.purchaseproductDetailPage-attrList .attr .attrValueList{
  overflow: hidden;
}
.purchaseproductDetailPage-attrList .attr .attrValueList .attrValue{
  float: left;
  padding: 5px 20px;
  margin: 0 10px 10px 0;
  background: #eee;
  border-radius: 5px;
  overflow: hidden;
}
.purchaseproductDetailPage-attrList .attr .attrValueList .attrValue .attrIcon{
  width: 20px;
  height: 20px;
  margin-right:5px;
  float: left;
}
.purchaseproductDetailPage-attrList .attr .attrValueList .attrValue .attrValueText{
  float: left;
}
.purchaseproductDetailPage-attrList .attr .attrValueList .attrValue.disabled{
  background: #eee;
  color:#ddd;
}
.purchaseproductDetailPage-attrList .attr .attrValueList .attrValue.select{
  background: red;
  color:white;
}
.purchaseproductDetailPage-attrList .attr .attrValueList .attrValue.canSelect{
  border:1px solid #ccc;
  color:black;
}
.purchaseproductDetailPage-attrList .attr .attrValueList .attrValue.cannotSelect{
  border:1px dashed #ccc;
  color:#ccc;
}
.purchaseproductDetailPage-attrList .attr .attrValueList .attrValue.select .attrIcon{
  border:1px solid white;
}
.purchaseproductDetailPage-jiajian{
  overflow: hidden;
}
.purchaseproductDetailPage-jiajian-ctrl{
  padding: 20px 10px;
  float: right;
}
.purchaseproductDetailPage-jiajian-ctrl span{
  float: left;
  width: 20px;
  text-align: center;
}
.purchaseproductDetailPage-jiajian-ctrl .count{
  border: 1px solid #eee;
  width: 30px;
  border-left: 0;
  border-right: 0;
}
.purchaseproductDetailPage-jiajian-ctrl .btn{
  border: 1px solid #eee;
}
.purchaseproductDetailPage-jiajian-ctrl .jian{
  border-radius:2px 0 0 2px;
}
.purchaseproductDetailPage-jiajian-ctrl .jia{
  border-radius:0 2px 2px 0;
}
.purchaseproductDetailPage-btn .btn{
  width: 100%;
  height: 50px;
  line-height: 50px;
  text-align: center;
  background: red;
  color: white;
}
.purchaseproductDetailPage-btn .btn.disabled{
  background: #ccc;
}


.purchaseproductDetailPage .pro-row.delivery-info {
}
.purchaseproductDetailPage .pro-row.delivery-info .item .fa{
  width: 20px;
  color:Red;
}



.productDetailInfo{
  background: white;
  padding-top: 48px;
}
.productDetailInfo .fontImgInfo img{ width: 100%; display: block;}


.purchaseproductDetailPage .specListDiv{
  background: white;
  overflow: hidden;
}
.purchaseproductDetailPage .specListDiv .specListTitle{
  text-align: center;
  line-height: 30px;
}
.purchaseproductDetailPage .specList{
  border-left:1px solid #eee;
  border-top:1px solid #eee;
  width: 95%;
  margin: 10px auto;
  text-align: center;
}
.purchaseproductDetailPage .specList td{
  border-right:1px solid #eee;
  border-bottom:1px solid #eee;
  line-height: 32px;
}
.purchaseproductDetailPage .specItemName{
  width: 40%;
}
.purchaseproductDetailPage .specItemValue{
  width: 60%;
}


.purchaseproductDetailEvalue{
  background: white;
  padding-top: 48px;
}
.purchaseproductDetailPage .id-sumary{
  background: white;
}
.purchaseproductDetailPage .id-sumary ul li{
  padding:1rem 0.5rem;
  list-style: none;
}
.purchaseproductDetailPage .id-sumary ul li .mu-divider{
  background-color: #f5f5f5;
}
.purchaseproductDetailPage .id-sumary ul li .timg{
  width: 9%;
  float: left;
  display:-webkit-box;
  display:-webkit-flex;
  display:-ms-flexbox;
  display:flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
      -ms-flex-pack: center;
          justify-content: center;
  overflow: hidden;
  border-radius: 50%;
  margin-right: 10px;
}
.purchaseproductDetailPage .id-sumary ul li .timg img{
  width: 100%;
  height: 100%;
}
.purchaseproductDetailPage .id-sumary ul li:last-child{
  -webkit-box-shadow:none;
          box-shadow:none;
}
.purchaseproductDetailPage .id-sumary ul li .nametime{
  display: block;
  color:#000;
  font-size: .75rem;
}
.purchaseproductDetailPage .id-sumary ul li .time{
  float: right;
  color: #999;
  font-size: 12px;
}
.purchaseproductDetailPage .id-sumary ul li p{
  color:#5A5655;
  font-size:14px;
  line-height: 1.4;
}
.purchaseproductDetailPage .id-sumary ul li p.content{
  clear:both;
  margin-top: 10px;
}
.purchaseproductDetailPage .id-sumary ul li p.content img
{
    width:50px;
    height:50px;
}
.purchaseproductDetailPage .id-sumary ul li .pj-img-list{
  overflow: hidden;
}
.purchaseproductDetailPage .id-sumary ul li .pj-img-list .dimg
{
  float: left;
  overflow: hidden;
  width:32%;
  margin-top: 8px;
  display:-webkit-box;
  display:-webkit-flex;
  display:-ms-flexbox;
  display:flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
      -ms-flex-pack: center;
          justify-content: center;
}
.purchaseproductDetailPage .id-sumary ul li .pj-img-list .dimg:nth-child(n+2){
  margin-left: 2%;
}
.purchaseproductDetailPage .id-sumary ul li .pj-img-list .dimg:nth-child(4){
  margin: 0;
  margin-top: 8px;
}
.purchaseproductDetailPage .id-sumary ul li .pj-img-list .dimg img{
    height: auto;
    width: auto;
    max-width: 100%;
    min-height: 100%;
}


.purchaseproductDetailPage .id-sumary .id-comments-dd{
  display: none;
  font-size: .75rem;
  line-height: 2;
  color:#5A5655;
}
.purchaseproductDetailPage .id-sumary .id-comments-dd:nth-child(2){
  display: block;
}

.purchaseproductDetailPage .xing-div
{
    height:18px;
    overflow:hidden;
    color:red;
    font-size: 12px;
}
.purchaseproductDetailPage .xing-div .fa-star{
  padding: 0 2px;
}

.purchaseproductDetailBottomButton{
  overflow: hidden;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 56px;
  background: white;
  border-top: 1px solid #eee;
  line-height: 56px;
  z-index: 4;
}
.purchaseproductDetailBottomButton .content{
  float: left;
  width: 50%;
  padding: 12px 0;
}
.purchaseproductDetailBottomButton .content .btn{
  float: left;
  width: 33%;
  text-align: center;
  color: #999;
  line-height: 16px;
}
.purchaseproductDetailBottomButton .content .btn.faved{
  color: red;
}
.purchaseproductDetailBottomButton .content .btn a{
  color: #999;
}
.purchaseproductDetailBottomButton .content .btn ~ .btn{
}
.purchaseproductDetailBottomButton .btn-list{
  float: left;
  width: 50%;
}
.purchaseproductDetailBottomButton .btn-list .btn{
  float: left;
  width: 50%;
  background: #FF9500;
  text-align: center;
  color:white;
}
.purchaseproductDetailBottomButton .btn-list .btn ~ .btn{
  background: #FF0036;
  border-left:1px solid #dedede;
}
.purchaseproductDetailBottomButton .btn-list .btn.disabled{
  background: #ccc;
}
.purchaseproductDetailBottomButton .productDetailServiceInfo{
  background: #fff;
  padding: 1rem;
}
.purchaseproductDetailBottomButton .mu-badge-container .mu-badge-float{
  right: 0;
}


</style>



// WEBPACK FOOTER //
// src/pages/wholesale/productDetail.vue